<div class="attachment" [ngStyle]="thumbnail()" (click)="openAttachment()">
  <span class="k-icon k-i-zoom-actual-size k-icon-48"></span>
</div>